module.exports = "/packs/practical_exam_medal-1288606f3b8326a3e99b2a90b8f95da4.png";